import { BooleanDimension, mrpaSelectedDimension, StringsEnumDimension } from '@orus.eu/dimensions'
// Live in this leaf package: the floor's cross-product UI element types are structural, so nothing central imports these dimensions.
import { mrpaProductVersions } from '@orus.eu/product'

export const mrpaProductVersionDimension = new StringsEnumDimension({
  name: 'mrpaProductVersion',
  displayKeys: { name: 'dimension_name_mrpa_product_version' },
  values: mrpaProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mrpaIsManufacturingSegmentDimension = new BooleanDimension({
  name: 'mrpaIsManufacturingSegment',
  displayKeys: { name: 'dimension_name_mrpa_is_manufacturing_segment' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: {
    lockedInQuoteFor: {
      client: mrpaSelectedDimension,
    },
  },
} as const)
